export const PAY_ORGANIZER_KEY_TO_LABEL: Record<string, string> = {
  amountPerPayPeriod: "Amount per Pay Period",
  businessExpenses: 'Business expenses',
  domesticSupportObligations: "Domestic support obligations",
  insurance: "Insurance",
  mandatoryContributionsForRetirementPlans: "Mandatory contributions for retirement plans",
  netPay: "Net Pay",
  otherDeductions: "Other deductions",
  overtimePerPayPeriod: "Overtime per Pay Period",
  payDate: "Pay Date",
  requiredRepaymentsOfRetirementFundLoans: "Required repayments of retirement fund loans",
  taxMedicareAndSocialSecurityDeductions: "Tax, Medicare, and Social Security deductions",
  unionDues: "Union dues",
  voluntaryContributionsForRetirementPlans: "Voluntary contributions for retirement plans",
};

export const TABLE_COLUMNS = [
  "Include in Monthly Totals",
  "Include in Means Test",
  "Employer",
  "Pay Date",
  "Amount per Pay Period",
  "Overtime per Pay Period",
  "Tax, Medicare, and Social Security deductions",
  "Mandatory contributions for retirement plans",
  "Voluntary contributions for retirement plans",
  "Required repayments of retirement fund loans",
  "Insurance",
  "Domestic support obligations",
  "Union dues",
  "Business expenses",
  "Other deductions",
  "Net Pay",
];
